import React from 'react';
import { OptionalText, HintText } from './styled';

interface OptionalHintProps {
  hint?: string;
}

export const OptionalHint = ({
  hint
}: OptionalHintProps): React.ReactElement => {
  return (
    <>
      <OptionalText>Valgfritt.</OptionalText>
      {hint && <HintText>{hint}</HintText>}
    </>
  );
};
